// extracted by mini-css-extract-plugin
export default {"main":"home_3_main__mbg0p"};